import React, { useEffect, useState } from 'react'
import LeftBar from "../Components/LeftBar";
import NavBarAccount from "../Components/NavBarAccount"; 
import defaultProfilePhoto from '../Images/defprofile.png';
import profpicHolder from '../Images/profimage.svg';

//
import { getAuth, onAuthStateChanged,signOut } from "firebase/auth";
import { app } from '../firebase.js';
import { getFirestore, collection, query, getDocs, where } from "@firebase/firestore"; 
import Badge from 'react-bootstrap/Badge'; 


function Profile() {
   const [userProfilePicture, setProfilePicture] = useState(defaultProfilePhoto);
    const [loggedInUser, setloggedInUser] = useState(""); 
    const [LoggedInphone, setLoggedInphone] = useState("07XXXXXX");
    const [status, setStatus] = useState("")
    const db = getFirestore(app);



    //mount stuff here
    
        const auth = getAuth();
        useEffect(() => {
            onAuthStateChanged(auth, (user) => {
                if (user) {
                    const uid = user.uid;
                    const userQuery = query(collection(db, "users"), where("userId", "==", uid));
    
                    // Fetch user data from Firestore
                    getDocs(userQuery).then((querySnapshot) => {
                        querySnapshot.forEach((docSnapshot) => {
                            const userData = docSnapshot.data();
                            setloggedInUser(userData.businessName);
                            setLoggedInphone(userData.phone);
                            setStatus(userData.status);
                            
                            // Check for profile and cover photos in Firebase
                            if (userData.profilePic) {
                                setProfilePicture(userData.profilePic);
                            }
                        });

                    });
                }else{

                }
            });
        }, [auth, db]);
    


  return (
    <div className="dashBCont">
    <LeftBar />
    <div className="dashBcontA">
      <NavBarAccount />
      <div className="DashContent myAccountStuff">

        <div className='profPicCont'> 
            <img src={userProfilePicture || profpicHolder} alt="Profile" />
        </div>
        <h2>{loggedInUser}</h2>
        <p>{LoggedInphone}</p>
         <h5>
        Status <Badge bg="secondary"> {status}</Badge>
      </h5>





      </div>
    </div>
    </div>
  )
}

export default Profile